import React from 'react';
import './style.scss';
import { NavLink } from 'react-router-dom';
import {
  LeaseFundThumbnail,
  DomesticRealEstateThumbnail,
  OverseasRealEstateThumbnail,
} from '../thumbnail';
import {
  LeaseFundBasicInfo,
  DomesticRealEstateBasicInfo,
  OverseasRealEstateBasicInfo,
} from '../basicInfo';
import { LeaseFundHalfInfo, DomesticRealEstateHalfInfo, OverseasRealEstateHalfInfo } from '../halfInfo';
import {
  SymbolDetailInfo,
  OverseasRealEstateSymbolDetailInfo,
} from 'views/utils/graphql/graphql';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
type CardProps = { to: string } & SymbolDetailInfo;

export const LeaseFundCard = (props: CardProps) => {
  const { to, ...symbolDetail } = props;
  return (
    <div className="leaseFund">
      <div className="programCard">
        <LeaseFundThumbnail {...symbolDetail} />
        <div className="programCard_wrapper">
          <LeaseFundBasicInfo isFull={false} {...symbolDetail} />
        </div>
        <div className="programCard_space" />
        <LeaseFundHalfInfo {...symbolDetail} />

        <NavLink to={to} className="programCard_detail">
          案件詳細を見る
        </NavLink>
      </div>
    </div>
  );
};

type DomesticRealEstateCardProps = { to: string } & DomesticRealEstateSymbolDetailInfo;

export const DomesticRealEstateCard = (props: DomesticRealEstateCardProps) => {
  const { to, ...symbolDetail } = props;
  return (
    <div className="domesticRealEstate">
      <div className="programCard">
        <DomesticRealEstateThumbnail {...symbolDetail} />
        <div className="programCard_wrapper">
          <DomesticRealEstateBasicInfo isFull={false} {...symbolDetail} />
        </div>
        <DomesticRealEstateHalfInfo {...symbolDetail} />
        <div className="programCard_space" />

        <NavLink to={to} className="programCard_detail">
          案件詳細を見る
        </NavLink>
      </div>
    </div>
  );
};

type OverseasRealEstateCardProps = { to: string } & OverseasRealEstateSymbolDetailInfo;

export const OverseasRealEstateCard = (props: OverseasRealEstateCardProps) => {
  const { to, ...symbolDetail } = props;
  return (
    <div className="overseasRealEstate">
      <div className="programCard">
        <OverseasRealEstateThumbnail {...symbolDetail} />
        <div className="programCard_wrapper">
          <OverseasRealEstateBasicInfo isFull={false} {...symbolDetail} />
        </div>
        <div className="programCard_space" />
        <OverseasRealEstateHalfInfo {...symbolDetail} />

        <NavLink to={to} className="programCard_detail">
          案件詳細を見る
        </NavLink>
      </div>
    </div>
  );
};
